import script from "./AdminLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLink.vue?vue&type=script&setup=true&lang=js"

import "./AdminLink.vue?vue&type=style&index=0&id=557332ae&lang=scss"

const __exports__ = script;

export default __exports__